import React from "react";
import styles from "./SmallCart.module.css";
import { FaShoppingCart } from "react-icons/fa";

const SmallCart = ({ totalQuantity, onCartClick }) => {
  // Receive the onCartClick function as a prop
  return (
    <>
      {totalQuantity > 0 && (
        <div className={styles.smallCart} onClick={onCartClick}>
          {/* <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            className={`${styles.cart}`}
          >
            <path
              fill="#FAFAFA"
              d="M22.3,-24.9C31.2,-19.2,42.2,-14.3,52.4,-2.5C62.5,9.3,71.8,28.1,65.6,37C59.4,45.8,37.7,44.9,19.8,49.1C1.9,53.4,-12.2,62.8,-18.8,57.7C-25.3,52.6,-24.3,33.1,-35.6,18.3C-46.8,3.5,-70.3,-6.5,-75,-19.1C-79.8,-31.6,-65.8,-46.7,-50.2,-51.3C-34.5,-55.8,-17.3,-49.9,-5.3,-43.6C6.7,-37.3,13.4,-30.7,22.3,-24.9Z"
              transform="translate(100 100)"
            />
          </svg> */}
          <FaShoppingCart className={styles.cart} />
          <div className={styles.bubble}>
            <span>{totalQuantity}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default SmallCart;
